//
// Card
//

'use strict';

// Cookies
/*
var Cookies = (function() {

	// Variables

	var $modal = $("#modal-cookies");


	// Methods

	function show($this) {
        var cookies = localStorage.getItem('modal_cookies');

        if(! cookies) {
            $this.modal('show')
        }
	}

	function hide($this) {
		$this.modal('hide')
	}

	// Events

	if ($modal.length) {
		show($modal);

        $modal.on('hidden.bs.modal', function (e) {
            localStorage.setItem('modal_cookies', 1);
        })
	}

})();

*/

/*
 * Bootstrap Cookie Alert by Wruczek
 * https://github.com/Wruczek/Bootstrap-Cookie-Alert
 * Released under MIT license
 */


(function () {

    var cookieAlert = document.querySelector(".cookiealert");
    var acceptCookies = document.querySelector(".acceptcookies");

    if (!cookieAlert) {
       return;
    }

    cookieAlert.offsetHeight; // Force browser to trigger reflow (https://stackoverflow.com/a/39451131)

    var cookies = localStorage.getItem('modal_cookies');

    // Show the alert if we cant find the "acceptCookies" cookie
    if (! cookies) {
        cookieAlert.classList.add("show");
        //cookieAlert.collapse('show');
    }

    // When clicking on the agree button, create a 1 year
    // cookie to remember user's choice and close the banner
    acceptCookies.addEventListener("click", function () {
        localStorage.setItem('modal_cookies', 1);
        cookieAlert.classList.remove("show");

        // dispatch the accept event
        window.dispatchEvent(new Event("cookieAlertAccept"))
    });
})();
